import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import capitalize from 'lodash/capitalize'
import styles from './col.module.scss'

const Col = ({
  className,
  children,
  span,
  pull,
  push,
  sm,
  md,
  lg,
  xl,
}) => {
  const variants = {
    span,
    pull,
    push,
    sm,
    md,
    lg,
    xl,
  }

  const generateClassNames = ( variants, extra = '' ) => {
    const classNames = []

    Object.entries( variants ).forEach( ([ key, value ]) => {
      if( ! value ) {
        return
      }
  
      if( key ) {
        if( key === 'span' ) {
          key = ''
        } else {
          key = capitalize( key )
        }
      }
  
      switch( typeof value ) {
        case 'number':
          classNames.push( styles[ `col${ extra }${ key }${ value }` ] )
          break
        case 'string':
          value = capitalize( value )
  
          classNames.push( styles[ `col${ extra }${ key }${ value }` ] )
          break
        case 'object':
          classNames.push( generateClassNames( value, key ) )
          break
        default:
          break
      }
    })

    return classNames.join( ' ' )
  }

  const classNamesFinal = classNames( styles.col, generateClassNames( variants ), className )

  return (
    <div className={ classNamesFinal }>
      { children }
    </div>
  )
}

Col.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  span: PropTypes.oneOfType([ PropTypes.string, PropTypes.number, PropTypes.object ]),
  pull: PropTypes.oneOfType([ PropTypes.string, PropTypes.number, PropTypes.object ]),
  push: PropTypes.oneOfType([ PropTypes.string, PropTypes.number, PropTypes.object ]),
  sm: PropTypes.oneOfType([ PropTypes.string, PropTypes.number, PropTypes.object ]),
  md: PropTypes.oneOfType([ PropTypes.string, PropTypes.number, PropTypes.object ]),
  lg: PropTypes.oneOfType([ PropTypes.string, PropTypes.number, PropTypes.object ]),
  xl: PropTypes.oneOfType([ PropTypes.string, PropTypes.number, PropTypes.object ]),
}

Col.defaultProps = {
  className: '',
  span: '',
  pull: '',
  push: '',
  sm: '',
  md: '',
  lg: '',
  xl: '',
}

export default Col